/**
 * Feature flags string parser class
 */

/**
 * FeatureFlagsParserFactory
 *
 * @class FeatureFlagsParserFactory
 * @memberof mwApp/auth
 * @see mwApp/auth
 * @return {Function} class
 *
 * @ngdoc factory
 * @name mwApp/auth.factory:FeatureFlagsParserFactory
 */
/* @ngInject */
export default function featureFlagsFactory () { // TODO: in progress...

  let featureFlags = null

  let featureFlagsCache = Object.create(null)

  /* === public === */
  function featureFlagsParser () {
    // if (!featureFlagsCache[flag]) {
    //   featureFlagsCache[flag] = flag
    // }

    // return featureFlagsCache[flag]
  }

  featureFlagsParser.setFlags = function (flags) {
    featureFlags = flags || {}
    featureFlagsCache = Object.create(null)
  }

  featureFlagsParser.check = function (key) {
    return featureFlags?.hasOwnProperty(key) ? featureFlags[key] === 'true' : false;
  }

  return featureFlagsParser
}
